import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getWorkedHoursReports(params: any): AxiosPromise {
    return EndPointService.get('/provider/report/worked', { params });
}

export default {
    getWorkedHoursReports,
};
